import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/date-list';
import TListGroupHeaderComponent from './components/date-group-list-header'
import TListGroupHeader1Component from "./components/date-group-t-list-header-1"
import ViewComponent from './components/date-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/date-form-new';
import Moment from 'moment';
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../../system/components/aggregate-moment";
import DateTimeUtils from "core/gd/utils/datetime-utils";
import normalizeDate from "../../import/normalize/normalize-date";
import FieldDateViewInImport from "../../import/view-in-preview/date-view-in-import";

export default class DateCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    /*listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id]
    }*/

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? Moment(customFieldsData[this.customField.id]).format("YYYY-MM-DD") : '';
    }

    getValue(item) {return !!item.customFieldsData[this.customField.id] ? DateTimeUtils.dateToMoment(item.customFieldsData[this.customField.id]) : null}

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE,
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => i.item.customFieldsData[this.customField.id] || ''
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get TListGroupHeader1Component() {
        return TListGroupHeaderComponent.bind(null, this.customField.id)
    }

    get TListGroupHeader2Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id)
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeDate(value);
    }

    getComponentViewInImport() {
        return FieldDateViewInImport;
    }
}